import type { MissionMembershipRole, UserAccessSnapshot } from '../contracts/types'
import type { CommandDeckMissionReadModelReaders } from './commandDeckMissionReadModel.types'

export interface LoadProjectMembershipRoleInput {
  uid?: string
  projectId: string
  access: UserAccessSnapshot
}

/**
 * Resolve project membership role (read-only). Never elevates to founder without explicit data.
 */
export function loadProjectMembershipRole(
  input: LoadProjectMembershipRoleInput,
  readers: Pick<CommandDeckMissionReadModelReaders, 'loadMembershipRole'>
): MissionMembershipRole | undefined {
  const fromRegistry = readers.loadMembershipRole({
    uid: input.uid,
    projectId: input.projectId,
    access: input.access,
  })
  if (fromRegistry) return fromRegistry

  if (input.access.accessState === 'founder_mode') return 'founder'
  return undefined
}
